import $, { css, get } from "jquery";
import { Fancybox } from "@fancyapps/ui";
import Swiper from "swiper/bundle";
import "./menu";
import "./cart";
import "./filter";
import "./mobile-filter";
import "magnific-popup";
import Inputmask from "inputmask";

// Fancybox bind

$(function ($) {
  let $mainImage = $("#main-gallery-image");
  let $thumbnails = $(".thumbnail-image");
  let swiperVertical;
  let autoSlideInterval;
  let currentIndex = 0;
  let totalSlides = $thumbnails.length;
  let initialized = false; //Add this variable

  function updateMainImage(index) {
    currentIndex = index;
    let $thumb = $thumbnails.eq(index);
    let newSrc = $thumb.data("large");
    let newFull = $thumb.data("full");

    $("#main-gallery-image").attr("src", newSrc);
    $("#main-gallery-link").attr("href", newFull);

    $thumbnails.removeClass("active");
    $thumb.addClass("active");
    initialized = true;
  }

  function initVerticalSwiper() {
    $(".thumb-swiper-container").show();

    swiperVertical = new Swiper(".thumb-swiper", {
      direction: "vertical",
      slidesPerView: 4,
      spaceBetween: 10,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      loop: true,
      watchSlidesProgress: true,
      on: {
        slideChangeTransitionEnd: function () {
          updateMainImage(swiperVertical.realIndex);
        },
      },
    });
  }

  function startAutoSlide() {
    clearInterval(autoSlideInterval);
    autoSlideInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateMainImage(currentIndex);
    }, 5000);
  }

  function checkScreenWidth() {
    let windowWidth = $(window).width();

    if (windowWidth > 1024) {
      if (!swiperVertical) {
        initVerticalSwiper();
      }

      $(".thumb-swiper-container").show();
      $(".single-gallery-buttons").hide();
      clearInterval(autoSlideInterval);
    } else {
      if (swiperVertical && typeof swiperVertical.destroy === "function") {
        swiperVertical.destroy(true, true);
        swiperVertical = null;
      }

      $(".thumb-swiper-container").hide();
      $(".single-gallery-buttons").show();
      startAutoSlide();
    }
  }

  checkScreenWidth();
  $(window).on("resize", checkScreenWidth);

  $thumbnails.each(function (index) {
    $(this).attr("data-index", index);
  });

  $thumbnails.on("click", function () {
    let clickedIndex = $(this).data("index");
    updateMainImage(clickedIndex);
    if (swiperVertical) {
      swiperVertical.slideToLoop(clickedIndex);
    }
  });

  $(".swiper-button-next").on("click", function () {
    if (swiperVertical) {
      swiperVertical.slideNext();
    } else {
      currentIndex = (currentIndex + 1) % totalSlides;
      updateMainImage(currentIndex);
    }
  });

  $(".swiper-button-prev").on("click", function () {
    if (swiperVertical) {
      swiperVertical.slidePrev();
    } else {
      currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
      updateMainImage(currentIndex);
    }
  });

  $mainImage.on("touchstart", function (event) {
    let startX = event.originalEvent.touches[0].clientX;

    $(this).on("touchmove", function (event) {
      let moveX = event.originalEvent.touches[0].clientX;
      let diff = startX - moveX;

      if (Math.abs(diff) > 50) {
        if (diff > 0) {
          currentIndex = (currentIndex + 1) % totalSlides;
        } else {
          currentIndex = (currentIndex - 1 + totalSlides) % totalSlides;
        }
        updateMainImage(currentIndex);
        $(this).off("touchmove");
      }
    });

    $(this).on("touchend", function () {
      $(this).off("touchmove touchend");
    });
  });

  updateMainImage(0);
  
  $("#main-gallery-link").on("click", function (e) {
    e.preventDefault();
      
    const $galleryLinks = $('[data-fancybox="product-gallery"]');
  
    const items = $galleryLinks
      .map(function () {
        const href = $(this).attr("href");
        return href ? { src: href, type: "image" } : null;
      })
      .get();
  
    if (items.length > 0) {
      Fancybox.show(items, {
        startIndex: 0,
        trapFocus: false,
        autoFocus: false,
        placeFocusBack: false,
        Thumbs: { autoStart: true },
          
        on: {
          close: () => {
            const $trigger = document.getElementById("main-gallery-link");
            if ($trigger) $trigger.focus();
          }
        }
      });
    }
  });
  
  $(".call-me-back").magnificPopup({
    items: {
      src: "#call-back-popup",
      type: "inline",
    },
    mainClass: "mfp-fade",
    removalDelay: 160,
    fixedContentPos: true,
    callbacks: {
      open: function () {
        //Create a wrapper for the close button
        if (!$(".popup-container .mfp-close-wrap").length) {
          $(".popup-container").append('<div class="mfp-close-wrap"></div>');
        }
        //Move .mfp-close inside the new wrapper .mfp-close-wrap
        $(".mfp-close").appendTo(".popup-container .mfp-close-wrap");
      },
    },
  });

  const swiper = new Swiper(".banners-swiper", {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    autoplay: {
      delay: 5000, //5000 ms = 5 seconds
      disableOnInteraction: false, //Continues Autoscrol after interaction
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
      },
      993: {
        slidesPerView: 2,
      },
    },
  });
  $(".feedback-toggle").on("click", function () {
    $(".feedback-container").toggleClass("active");
  });

  $(document).on("click", function (event) {
    if (!$(event.target).closest(".feedback-container").length) {
      $(".feedback-container").removeClass("active");
    }
  });

  $(document).on("click", "#place_order", function () {
    setTimeout(function () {
      $(".checkout-inline-error-message").each(function () {
        var $msg = $(this);
        var text = $msg.text();
        if (text.startsWith("Оплата ")) {
          $msg.text(text.replace(/^Оплата\s+/, ""));
        }
      });
    }, 100);
  });


  function alignFilterScrollPadding($el, targetPadding = 20) {
    const scrollHeight = $el[0].scrollHeight;
    const clientHeight = $el[0].clientHeight;
    const hasScroll = scrollHeight > clientHeight;
  
    //Width Skrolbaru
    const scrollDiv = $('<div>').css({
      width: '100px',
      height: '100px',
      overflowY: 'scroll',
      position: 'absolute',
      top: '-9999px'
    }).appendTo('body');
  
    const scrollbarWidth = scrollDiv[0].offsetWidth - scrollDiv[0].clientWidth;
    scrollDiv.remove();
  
    const finalPadding = hasScroll ? (targetPadding - scrollbarWidth) : targetPadding;
    $el.css('padding-right', `${finalPadding}px`);
  }
  
  function alignAllFilterScrolls() {
    $('.filter-scroll').each(function () {
      alignFilterScrollPadding($(this), 18);
    });
  }
  
  //The first launch
  $(window).on('load resize', alignAllFilterScrolls);
  
  
});

document.addEventListener("DOMContentLoaded", () => {
  const phoneInputs = document.querySelectorAll('input[type="tel"]');

  phoneInputs.forEach((input) => {
    Inputmask({ mask: "+38 (099) 999-99-99" }).mask(input);
  });
});
